import type { ReactNode } from 'react';

export type PillVariant = 'ok' | 'warn' | 'err' | 'info' | 'muted';

export interface PillProps {
  variant: PillVariant;
  children: ReactNode;
  icon?: ReactNode;
}

/** Primitive 2: Pill. */
export function Pill({ variant, children, icon }: PillProps): JSX.Element {
  return (
    <span className={`pill pill-${variant}`}>
      {icon && <span aria-hidden>{icon}</span>}
      {children}
    </span>
  );
}
